import { Link } from "react-router-dom";

import { LogoMark } from "@/components/branding/LogoMark";
import { MOSQUE } from "@/config/constants";

export function Footer() {
  return (
    <footer className="hidden border-t border-line bg-paper py-6 text-sm text-muted sm:block">
      <div className="container-wide flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <LogoMark className="h-7 w-auto shrink-0" />
          <p>
            {MOSQUE.name} · {MOSQUE.village}, {MOSQUE.district}, {MOSQUE.country}
          </p>
        </div>
        <nav aria-label="Footer">
          <ul className="flex flex-wrap gap-x-4 gap-y-1">
            <li>
              <Link to="/about" className="hover:text-ink">
                About
              </Link>
            </li>
            <li>
              <Link to="/committee" className="hover:text-ink">
                Committee
              </Link>
            </li>
            <li>
              <Link to="/contribute" className="hover:text-ink">
                Contribute
              </Link>
            </li>
            <li>
              <Link to="/community" className="hover:text-ink">
                Community
              </Link>
            </li>
            <li>
              <Link to="/admin" className="hover:text-ink">
                Admin
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
